import React, { useState, useEffect } from "react";

const CursorPopup = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setPopupPosition({ top: e.clientY, left: e.clientX });
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const showPopup = () => {
    setIsVisible(true);
  };

  const hidePopup = () => {
    setIsVisible(false);
  };

  return (
    <div>
      <div onMouseEnter={showPopup} onMouseLeave={hidePopup}>
        {/* Display short version of the text */}
        {props.ShortText}
        {/* Popup */}
        {isVisible && (
          <div
            style={{
              position: "fixed",
              top: popupPosition.top + 10, // Adjust the top position as needed
              left: popupPosition.left,
              pointerEvents: "none",
              color: "white !important",
              zIndex: 99,
            }}
          >
            <p className="popup-text">{props.FullText}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CursorPopup;
